/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { ToastContainer } from "react-toastify"
import GDPR from "./gdpr"

import Header from "./header"
import Footer from "./footer"
import "tachyons"
import "react-toastify/dist/ReactToastify.min.css"

const Layout = ({ children }: { children: React.ReactNode }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <div className="w-100 m0 min-vh-100 baskerville bg-purple">
      <Header siteTitle={data.site.siteMetadata.title} />
      <main className="w-100 w-90-l center bg-white br3">{children}</main>
      <ToastContainer position="top-center" />
      <Footer />
      <GDPR />
    </div>
  )
}

export default Layout
